import { api } from "@/lib/axios"
import type { DashboardResponse } from "@/types/dashboard"

export async function fetchDashboard(): Promise<DashboardResponse> {
  const { data } = await api.get<DashboardResponse>("/admin/dashboard/")
  return data
}
